/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
// import MDBadge from "components/MDBadge";

import { useNavigate } from "react-router-dom";

import { useEffect, useMemo, useRef, useState } from "react";
import { db } from "firebaseDb";
import { query, where, onSnapshot, collection } from "firebase/firestore";
import { Icon, Tooltip } from "@mui/material";
import { useAuth } from "layouts/authentication/AuthContext"; // Import useAuth
import Badge from "@mui/material/Badge";
import Stack from "@mui/material/Stack";

function normalizeCode(value) {
  return typeof value === "string" ? value.trim().toUpperCase() : "";
}
const S4232_CODE = normalizeCode("S4232");

export default function data(
  handleOpenDialog,
  handleOpenPublishDialog,
  handleOpenUnpublishDialog,
  handleOpenMoveToReadyDialog
) {
  const navigate = useNavigate();
  const { user } = useAuth(); // Access the user object from AuthContext
  const [sprays, setSprays] = useState([]);
  const [isCopyButtonClicked, setIsCopyButtonClicked] = useState(false);
  const [sprayDataMap, setSprayDataMap] = useState(new Map());
  const sprayDataMapRef = useRef(sprayDataMap);

  useEffect(() => {
    sprayDataMapRef.current = sprayDataMap;
  }, [sprayDataMap]);

  useEffect(() => {
    if (!user) return;
    const elevenMonthsAgo = new Date();
    elevenMonthsAgo.setMonth(elevenMonthsAgo.getMonth() - 8);
    const sprayRef = collection(db, "Sprays");

    const isOwner = user.permissions === "Owner";
    if (isOwner && !user.uid) {
      setSprays([]);
      return () => {};
    }

    const ownerBaseFilter = isOwner ? [where("ownerUIDs", "array-contains", user.uid)] : [];

    const querySpecs = [
      {
        key: "dated-owner",
        ref: query(
          sprayRef,
          ...ownerBaseFilter,
          where("sprayDate", ">=", elevenMonthsAgo),
          where("archive", "==", false)
        ),
      },
      {
        key: "undated-owner",
        ref: query(
          sprayRef,
          ...ownerBaseFilter,
          where("sprayDate", "==", ""),
          where("archive", "==", false)
        ),
      },
    ];

    if (!isOwner) {
      querySpecs[0].key = "dated";
      querySpecs[1].key = "undated";
    }

    const snapshotsByKey = new Map();

    const updateSprays = () => {
      const spraysById = new Map();
      const nextSprayDataMap = new Map();
      snapshotsByKey.forEach((snapshot) => {
        snapshot.forEach((docu) => {
          const sprayData = docu.data();
          nextSprayDataMap.set(docu.id, sprayData);

          let blockString = "";
          const blockStringArray = [];

          if (typeof sprayData.blockVarieties !== "string") {
            for (let i = 0; i < sprayData.blockVarieties.length; i++) {
              if (sprayData.blockVarieties[i].block.checked) {
                blockStringArray.push(`Block ${sprayData.blockVarieties[i].block.code}`);
              }
            }

            blockString =
              blockStringArray.length === sprayData.blockVarieties.length
                ? "All Blocks"
                : blockStringArray.join(",");
          } else {
            blockString = sprayData.blockVarieties;
          }

          // Determine if any chemical is missing a batchNo
          const isArrayChemicals = Array.isArray(sprayData.chemicals);
          const missingBatchNo =
            isArrayChemicals &&
            sprayData.chemicals.some((chem) => !chem.batchNo || chem.batchNo === "");
          const orchardText = [sprayData.siteCode, sprayData.siteName].join("\r\n");

          spraysById.set(docu.id, {
            sprayID: sprayData.sprayInstructionId,
            growthStage: sprayData.growthStage,
            orchard: orchardText,
            orchardSiteCode: normalizeCode(sprayData.siteCode),
            orchardNuPointJobID:
              sprayData.NuPointJobID !== undefined &&
              sprayData.NuPointJobID !== null &&
              String(sprayData.NuPointJobID).trim() !== "undefined"
                ? String(sprayData.NuPointJobID).trim()
                : "",
            date:
              typeof sprayData.sprayDate === "string"
                ? sprayData.sprayDate.slice(0, -9)
                : sprayData.sprayDate.toDate().toLocaleString("en-GB", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                  }),
            status: sprayData.status,
            weedspray: sprayData.weedspray,
            operator:
              typeof sprayData.operatorWorker === "string"
                ? sprayData.operatorWorker.split(",").join("\r\n")
                : sprayData.operatorWorker.join("\r\n"),
            operatorNotes: (sprayData.opNotes || "").trim(),
            chemicals:
              typeof sprayData.chemicals === "string"
                ? sprayData.chemicals.split(",").join("\r\n")
                : sprayData.chemicals.map((c) => c.chemicalName).join(", "),
            missingBatchNo,
            isArrayChemicals,
            blocks: blockString,
            key: docu.id,
            sprayInstructionId: sprayData.sprayInstructionId,
          });
        });
      });
      setSprays(Array.from(spraysById.values()));
      setSprayDataMap(nextSprayDataMap);
    };

    const unsubscribes = querySpecs.map(({ key, ref }) =>
      onSnapshot(ref, (snapshot) => {
        snapshotsByKey.set(key, snapshot);
        if (snapshotsByKey.size === querySpecs.length) {
          updateSprays();
        }
      })
    );

    return () => {
      unsubscribes.forEach((unsubscribe) => unsubscribe());
      snapshotsByKey.clear();
      setSprays([]);
    };
  }, [user]); // Add user as a dependency to re-render when permissions change

  const columns = useMemo(() => {
    const mappedColumns = [
      { Header: "spray id", accessor: "sprayID", align: "left" },
      { Header: "date", accessor: "date", align: "left" },
      {
        Header: "Orchard",
        accessor: "orchard",
        align: "left",
        Cell: ({ row }) => {
          const nuPointJobID = row.original.orchardNuPointJobID;
          const isS4232 = row.original.orchardSiteCode === S4232_CODE;
          if (!isS4232) {
            return <span style={{ whiteSpace: "pre-line" }}>{row.original.orchard}</span>;
          }
          return (
            <MDBox display="flex" alignItems="center" gap={0.5}>
              <span style={{ whiteSpace: "pre-line" }}>{row.original.orchard}</span>
              {nuPointJobID ? (
                <Tooltip title={`NuPoint Job ID: ${nuPointJobID}`} arrow placement="top">
                  <Icon
                    fontSize="small"
                    sx={{ color: "success.main", cursor: "default" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    check_circle
                  </Icon>
                </Tooltip>
              ) : (
                <Tooltip title="No NuPoint Job ID" arrow placement="top">
                  <Icon fontSize="small" sx={{ color: "warning.main", cursor: "default" }}>
                    warning
                  </Icon>
                </Tooltip>
              )}
            </MDBox>
          );
        },
      },
      {
        Header: "blocks",
        accessor: "blocks",
        align: "center",
        Cell: ({ value }) => (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox ml={1} lineHeight={3} sx={{ maxWidth: "150px" }}>
              {String(value || "")
                .split(",")
                .filter(Boolean)
                .map((block) => (
                  <MDTypography key={block} display="block" variant="button" fontWeight="medium">
                    {block}
                  </MDTypography>
                ))}
            </MDBox>
          </MDBox>
        ),
      },
      { Header: "operator", accessor: "operator", align: "center" },
      {
        Header: "Operator Notes",
        accessor: "operatorNotes",
        align: "center",
        Cell: ({ value }) =>
          value ? (
            <Tooltip title={value} arrow placement="top">
              <Icon fontSize="small" color="action">
                sticky_note_2
              </Icon>
            </Tooltip>
          ) : null,
      },
      { Header: "Stage", accessor: "growthStage", align: "center" },
      {
        Header: "Chemicals",
        accessor: "chemicals",
        align: "center",
        Cell: ({ row }) =>
          row.original.isArrayChemicals ? (
            <Stack direction="row" spacing={1} alignItems="center">
              <span>{row.original.chemicals}</span>
              <Badge
                color="error"
                variant="dot"
                invisible={!row.original.missingBatchNo}
                anchorOrigin={{ vertical: "top", horizontal: "left" }}
              />
            </Stack>
          ) : (
            row.original.chemicals
          ),
      },
    ];

    if (user?.permissions === "Admin") {
      mappedColumns.push({
        Header: "action",
        accessor: "action",
        align: "center",
        Cell: ({ row }) => {
          const spray = sprayDataMapRef.current.get(row.original.key);
          if (!spray) return null;

          return (
            <MDBox>
              {spray.status !== "Published" && (
                <MDButton
                  size="medium"
                  iconOnly
                  color="info"
                  disabled={spray.sprayInstructionId < 20000}
                  onClick={(event) => {
                    event.stopPropagation();
                    setIsCopyButtonClicked(true);
                    navigate("/sprays/clonespray", {
                      state: {
                        data: {
                          ...spray,
                          sprayDate: spray.sprayDate ? spray.sprayDate.toDate() : "",
                        },
                      },
                    });
                  }}
                >
                  <Icon>copy</Icon>
                </MDButton>
              )}
              {spray.status !== "Published" && (
                <MDButton
                  size="medium"
                  iconOnly
                  color="warning"
                  sx={{ marginLeft: "3px" }}
                  disabled={spray.sprayInstructionId < 20000}
                  onClick={(event) => {
                    event.stopPropagation();
                    setIsCopyButtonClicked(true);
                    navigate(`/editspray/${spray.sprayInstructionId}`, {
                      state: {
                        data: {
                          ...spray,
                          sprayDate: spray.sprayDate ? spray.sprayDate.toDate() : "",
                          key: row.original.key,
                        },
                      },
                    });
                  }}
                >
                  <Icon>edit</Icon>
                </MDButton>
              )}
              {spray.status !== "Published" && (
                <MDButton
                  size="medium"
                  iconOnly
                  sx={{ marginLeft: "3px" }}
                  color="error"
                  disabled={spray.sprayInstructionId < 20000}
                  onClick={(event) => {
                    event.stopPropagation();
                    setIsCopyButtonClicked(true);
                    handleOpenDialog(spray.sprayInstructionId);
                  }}
                >
                  <Icon>delete</Icon>
                </MDButton>
              )}
              {spray.status === "Sprayed" && (
                <MDButton
                  size="medium"
                  iconOnly
                  sx={{ marginLeft: "3px" }}
                  color="primary"
                  disabled={spray.sprayInstructionId < 20000}
                  onClick={(event) => {
                    event.stopPropagation();
                    setIsCopyButtonClicked(true);
                    handleOpenMoveToReadyDialog(spray.sprayInstructionId);
                  }}
                >
                  <Icon>undo</Icon>
                </MDButton>
              )}
              {spray.status === "Sprayed" && (
                <MDButton
                  size="medium"
                  iconOnly
                  sx={{ marginLeft: "3px" }}
                  color="secondary"
                  disabled={spray.sprayInstructionId < 20000}
                  onClick={(event) => {
                    event.stopPropagation();
                    setIsCopyButtonClicked(true);
                    handleOpenPublishDialog(spray);
                  }}
                >
                  <Icon>publish</Icon>
                </MDButton>
              )}
              {spray.status === "Published" && (
                <MDButton
                  size="medium"
                  iconOnly
                  sx={{ marginLeft: "3px" }}
                  color="primary"
                  disabled={spray.sprayInstructionId < 20000}
                  onClick={(event) => {
                    event.stopPropagation();
                    setIsCopyButtonClicked(true);
                    handleOpenUnpublishDialog(spray.sprayInstructionId);
                  }}
                >
                  <Icon>settings_backup_restore</Icon>
                </MDButton>
              )}
            </MDBox>
          );
        },
      });
    }
    return mappedColumns;
  }, [
    user?.permissions,
    navigate,
    handleOpenDialog,
    handleOpenPublishDialog,
    handleOpenUnpublishDialog,
    handleOpenMoveToReadyDialog,
    setIsCopyButtonClicked,
  ]);

  const visibleSprays = useMemo(() => {
    if (!user || !Array.isArray(sprays)) return [];
    if (user.permissions === "Orchard" && Array.isArray(user.orchards)) {
      const normalizedAllowedOrchards = user.orchards
        .map((orch) => normalizeCode(orch))
        .filter(Boolean);
      return sprays.filter((spray) => normalizedAllowedOrchards.includes(spray.orchardSiteCode));
    }
    return sprays;
  }, [user, sprays]);

  return {
    columns,
    rows: visibleSprays,
    clickEvent: isCopyButtonClicked,
  };
}
